<i18n>
{
	"en": {
		"unableToFindEdiLog":"Unable to find outbound EDI for stretch",
		"ediHasBeenSentTo": "EDI sent to: ",
		"ediHasBeenSentDate": "Date: "
	},
	"no": {
		"unableToFindEdiLog":"Fant ikke utgående EDI for gjeldende strekning",
		"ediHasBeenSentTo": "EDI sendt til ",
		"ediHasBeenSentDate": "Dato: ",
		"ediHasBeenSentWithPartAndDate": "EDI sendt til {0}: {1}"
	}
}
</i18n>

<template>

	<div
		class="container"
		:class="{ isCurrentSuborder: isCurrentSuborder }"

		v-on="$listeners"

		@contextmenu="_onContextMenu"
	>
		<div class="header">
			<p class="name-header first">
				{{despatchParty.name}}
			</p>
			<div>
				<TToolTip v-if="hasBeenSentOnEdi" flex>
					<template slot="target">
						<t-timpex-icon
							icon="edi"
							size="small"
							type="bp"
							:color="getEdiColor"
							style="cursor: pointer"
							@click.native="displayEdiTransmission"
						/>

					</template>
					<div>{{getEdiDisplayedValue()}}</div>
				</TToolTip>
			</div>

		</div>

		<p class="place-header">{{despatchParty.postalPlace}} {{despatchParty.postalCode}}</p>

		<p class="name-header">
			{{deliveryParty.name}}
		</p>

		<p class="place-header">{{deliveryParty.postalPlace}} {{deliveryParty.postalCode}}</p>

		<t-form-group slot="footer" margin-top="10px" horizontal>
			<t-badge :isSolid="isUsingAtd" :value="departure"/>
			<t-badge :isSolid="isUsingAta" :value="arrival"/>
		</t-form-group>

		<t-popover
			ref="contextMenu"
			closeOnClick
			closeOnRightClick
			@open="contextMenuOpen = true"
			@close="contextMenuOpen = false;"
		>
			<slot name="contextMenu" />
		</t-popover>

		<InspectOutboundTransmissionDialog :isShown="showOutboundDialog" @close="showOutboundDialog = false" />
	</div>
</template>

<script>

import { displayDateFormatter } from '@/core';
import TBadge from '@/components/evergreen/badges/TBadge';
import  { mapActions as outboundActions }  from '../../edi/transmissionOverview/inspection/outbound/store/outbound.store';
import { mapState } from '../store/newOrder.store';
import InspectOutboundTransmissionDialog from '../../edi/transmissionOverview/inspection/outbound/InspectOutboundTransmissionDialog.vue';
import moment from 'moment';

export default {
	name: 'SubOrderListCard',
	components: { TBadge, InspectOutboundTransmissionDialog },
	props: {
		despatchParty: {
			type: Object,
			required: true,
			default() { return {}; }
		},
		deliveryParty: {
			type: Object,
			required: true,
			default() { return {}; }
		},
		isUsingAtd: {
			type: Boolean,
			required: true,
		},
		isUsingAta: {
			type: Boolean,
			required: true,
		},
		edi: Object,
		etd: Object,
		eta: Object,
		atd: Object,
		ata: Object,
		subOrderId: String,
		isCurrentSuborder: Boolean,
	},
	data() {
		return { contextMenuOpen: false, showOutboundDialog: false, ediInstructionLog: {} };
	},
	computed: {
		...mapState(['ediLog']),
		getEdiColor() {
			if (this.edi.outboundSchedule && this.edi.outboundSchedule.failed && !this.edi.outboundSchedule.isSent)
				return 'red';
			else if (!this.edi.outboundSchedule.failed && this.edi.outboundSchedule.isSent)
				return 'green';
			else
				return 'orange';
		},

		hasBeenSentOnEdi() {
			return this.ediLog.some(x => x.type === 'outbound' && x.messageTypeNo === '2');
		},
		departure() {
			return this.isUsingAtd
				? `ATD ${this.formatDateObject(this.atd)}`
				: `ETD ${this.formatDateObject(this.etd)}`;
		},
		arrival() {
			return this.isUsingAta
				? `ATA ${this.formatDateObject(this.ata)}`
				: `ETA ${this.formatDateObject(this.eta)}`;
		}
	},
	methods: {
		...outboundActions(['inspectOutboundTransmission']),
		formatDateObject(dateObj) {
			if (!dateObj || !dateObj.date) {
				return '';
			}
			return displayDateFormatter(dateObj.date);
		},

		getEdiDisplayedValue() {
			let ediLog = [...this.ediLog]
				.sort((x, y) => y.created.date - x.created.date)
				.find(
					x => x.messageTypeNo === '2'
					&& x.type === 'outbound'
					&& x.subOrderId === this.subOrderId
				);
			return this.$t('ediHasBeenSentWithPartAndDate', [ediLog.edipartName, moment(ediLog.created.date, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm:ss')]);
		},
		async displayEdiTransmission() {
			let ediLog = this.ediLog.find(x => x.messageTypeNo === '2' && x.type === 'outbound' && x.subOrderId === this.subOrderId);
			if (!ediLog) {
				this.$notify({
					type: 'error',
					title: this.$t('unableToFindEdiLog')
				});
				return;
			}
			await this.inspectOutboundTransmission(ediLog.transmissionId);
			this.showOutboundDialog = true;
		},
		_onContextMenu(event) {
			let popover = this.$refs.contextMenu;
			if (this.$scopedSlots['contextMenu'] && popover) {
				popover.open({ top: event.clientY, left: event.clientX });
				event.preventDefault();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
@import '~@/components/evergreen/scss/colors';

.container.isCurrentSuborder {
	background-color: rgba(16, 112, 202, 0.09);
}

.header{
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.name-header {
	font-size: 14px;
	line-height: 1em;
	font-weight: 600;
	margin: 8px 0 0 0;
	color: get-color($text, 'dark');
	text-transform: uppercase;
}

.name-header.first {
	 margin-top: 0px;
 }

.place-header {
	margin: 0 0 0;
	font-size: 11px;
	font-weight: 600;
	color: get-color($text, 'muted');
}

</style>